var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-input"},[_c('div',{staticClass:"input-content"},[_c('button',{on:{"click":_vm.minus}},[_vm._v(" － ")]),_c('p',[_vm._v(" "+_vm._s(_vm.inner)+" ")]),_c('button',{on:{"click":_vm.plus}},[_vm._v(" ＋ ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }